export const news = [
  {
    month: "May",
    year: 2026,
    summary:
      'Graduated from ASU with my MS in Computer Science and defended my thesis on strategies for structured data generation. <a href="https://docs.google.com/presentation/d/e/2PACX-1vRU7GFMrWl2TFztQg9OP3EggJ27-uXzGz_IhMrpkzWRGURqlHGSnJmn2fcYjX-HXCXayQQNr_cvwLUc/pub?start=true&loop=false&delayms=3000&slide=id.g3de3b1b7709_0_586" style="text-decoration:underline">Thesis presentation slides</a>.',
  },
  {
    month: "Apr",
    year: 2026,
    summary:
      '<a href="https://arxiv.org/abs/2510.18173" style="text-decoration:underline">Moneyball with LLMs: Analyzing Tabular Summarization in Sports Narratives</a> accepted at ACL 2026.',
  },
  {
    month: "Apr",
    year: 2026,
    summary:
      '<a href="https://arxiv.org/abs/2604.14165" style="text-decoration:underline">EviSearch: A Human in the Loop System for Extracting and Auditing Clinical Evidence for Systematic Reviews</a>. <a href="https://evisearch-web-488637739109.us-central1.run.app/" style="text-decoration:underline">Try it out</a>.',
  },
  {
    month: "Apr",
    year: 2026,
    summary:
      'Received the <a href="https://research.rice.edu/opd/ibm-masters-fellowship-award" style="text-decoration:underline">IBM Infrastructure Master&apos;s Fellowship</a> for AI research, featured by <a href="https://news.asu.edu/20260430-sun-devil-community-computer-science-grad-earns-ibm-fellowship-ai-research" style="text-decoration:underline">ASU News</a>.',
  },
  {
    month: "Oct",
    year: 2025,
    summary:
      '<a href="https://aclanthology.org/2025.ijcnlp-demo.11/" style="text-decoration:underline">SPORTSQL: An Interactive System for Real-Time Sports Reasoning and Visualization</a> accepted to the AACL 2025 Demo Track.',
  },
  {
    month: "May",
    year: 2025,
    summary:
      "Started a summer internship at AWS in Seattle, working on developer tool discovery and recommendation systems.",
  },
  {
    month: "Jan",
    year: 2025,
    summary:
      '<a href="https://aclanthology.org/2025.acl-long.1460/" style="text-decoration:underline">Map&Make: Schema-Guided Text-to-Table Generation</a> accepted at ACL 2025.',
  },
  {
    month: "Jan",
    year: 2025,
    summary:
      "Started as a teaching assistant for CSE 576: Topics in NLP under Professor Vivek Gupta at Arizona State University.",
  },
  {
    month: "Oct",
    year: 2024,
    summary:
      "Built a mentor-mentee scheduling system for Steam SuperHeroes NGO and secured 2nd place at Opportunity Hack 2024.",
  },
  {
    month: "Sep",
    year: 2024,
    summary:
      "Joined CoRAL Lab as a research assistant with Dr. Vivek Gupta, working on structure generation with LLMs and clinical trial analysis using agentic RAG systems.",
  },
  {
    month: "Aug",
    year: 2024,
    summary:
      "Began my Master's journey at Arizona State University, focusing on table generation and agentic AI.",
  },
  {
    month: "May",
    year: 2022,
    summary:
      'Selected as a <a href="https://www.mitacs.ca/en/programs/globalink/globalink-research-internship" style="text-decoration:underline">MITACS Globalink Research Scholar</a> at Lakehead University.',
  },
  {
    month: "Dec",
    year: 2021,
    summary:
      "Recognized on the Dean's Merit List for two consecutive semesters for academic excellence.",
  },
];
